import { render } from "./VueMultiSelect.vue?vue&type=template&id=6df90734&ts=true"
import script from "./VueMultiSelect.vue?vue&type=script&lang=ts"
export * from "./VueMultiSelect.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__